export function saveIdToLocalStorage(id) {
    localStorage.setItem('id', id);
  }
  

  export function getIdFromLocalStorage() {
    return localStorage.getItem('id');
  }
  
  export function removeIdFromLocalStorage() {
    localStorage.removeItem('id');
  }
  
export function saveJsonToLocalStorage(jsonObject) {
  const jsonString = JSON.stringify(jsonObject);
  localStorage.setItem('data', jsonString);
}

export function getJsonFromLocalStorage() {
  const jsonString = localStorage.getItem('data');
  return jsonString ? JSON.parse(jsonString) : null;
}

export function removeJsonFromLocalStorage() {
  localStorage.removeItem('data');
}

